export default __webpack_public_path__ + "static/media/error.4bb81ea4.jpg";